const KWSaunas = function() {
    function KWSaunas() {
        this.selector = {
            container: document.querySelectorAll(".kw-saunas-container")
        }
        this.load();
    }
    KWSaunas.prototype.load = function() {
        var _ = this;        
        let loaded = false;
        window.addEventListener("scroll", function() {
            if(_.selector.container.length > 0 && !loaded && window.scrollY > 10) {
                _.selector.container.forEach(el => {
                    el.innerHTML = el.dataset.content;
                })
                loaded = true;
            }
        })
    }
    KWSaunas = new KWSaunas;
}
KWSaunas();